/**
 * 弹出通知请求接口
 * @author 王振宇
 * @since 2022-06-28
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_POP_NOTICE_PAGE_LIST: function GET_POP_NOTICE_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/notice/getPageList',
        method: 'post',
        data: data
      });
    },
    ADD_POP_NOTICE: function ADD_POP_NOTICE() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/notice/addNotice',
        method: 'post',
        data: data
      });
    },
    UPDATE_POP_NOTICE: function UPDATE_POP_NOTICE() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/notice/updateNotice',
        method: 'post',
        data: data
      });
    },
    DELETE_POP_NOTICE: function DELETE_POP_NOTICE() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/notice/deleteNotice',
        method: 'post',
        data: data
      });
    }
  };
});